export default class HeaderAnimator {
    constructor() {
        this.body = document.body;
        this.divBrands = document.querySelectorAll('.navbar-brand');
        this.divVideos = document.querySelectorAll('.section-background-video');
    }

    init() {
        // Note: If a page doesn't have a video, the body will NEVER get
        // the 'animate-is-loaded' class. If that is intentional, keep this.
        if (!this.divVideos.length) {
            return;
        }
        this.triggerAnimations();
    }

    triggerAnimations() {
        // 1. Add class to body immediately
        this.body.classList.add('animate-is-loaded');

        // 2. Add classes to the NodeLists after the timeout
        setTimeout(() => {
            this.divBrands.forEach(brand => brand.classList.add('is-animated'));
            this.divVideos.forEach(video => video.classList.add('is-animated'));
        }, 360);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new HeaderAnimator().init();
});